module.exports = __webpack_public_path__ + "img/ic_im.8a5d0748.svg";